import {TextToolTip} from "components";
import {DeleteActionBtn, EditActionBtn} from "components";
import {allStatusesList, Statuses} from "fragments";
import {Svg} from "assets";

export const FacilityTypes = {
    HOSPITAL: "HOSPITAL",
    AIRPORT: "AIRPORT",
    ASSISTED_LIVING: "ASSISTED_LIVING",
    BOARD_CARE: "BOARD_CARE",
    COMPREHENSIVE_CARE: "COMPREHENSIVE_CARE",
    DIALYSIS_CENTER: "DIALYSIS_CENTER",
    DOCTORS_OFFICE: "DOCTORS_OFFICE",
    HOSPICE: "HOSPICE",
    IMAGING_CENTER: "IMAGING_CENTER",
    MEDICAL_CLINIC: "MEDICAL_CLINIC",
    REHABILITATION: "REHABILITATION",
    RETIREMENT_HOME: "RETIREMENT_HOME",
    SNF: "SNF",
    OTHER: "OTHER",
};

export const FacilityTypesList = [
    {
        id: FacilityTypes.HOSPITAL,
        name: "Hospital",
    },

    {
        id: FacilityTypes.AIRPORT,
        name: "Airport",
    },

    {
        id: FacilityTypes.ASSISTED_LIVING,
        name: "Assisted Living",
    },

    {
        id: FacilityTypes.BOARD_CARE,
        name: "Board & Care",
    },

    {
        id: FacilityTypes.COMPREHENSIVE_CARE,
        name: "Comprehensive Care",
    },

    {
        id: FacilityTypes.DIALYSIS_CENTER,
        name: "Dialysis Center",
    },

    {
        id: FacilityTypes.DOCTORS_OFFICE,
        name: "Doctor’s Office",
    },

    {
        id: FacilityTypes.HOSPICE,
        name: "Hospice",
    },

    {
        id: FacilityTypes.IMAGING_CENTER,
        name: "Imaging Center",
    },

    {
        id: FacilityTypes.MEDICAL_CLINIC,
        name: "Medical Clinic",
    },

    {
        id: FacilityTypes.REHABILITATION,
        name: "Rehabilitation Center",
    },

    {
        id: FacilityTypes.RETIREMENT_HOME,
        name: "Retirement Home",
    },

    {
        id: FacilityTypes.SNF,
        name: "SNF",
    },

    {
        id: FacilityTypes.OTHER,
        name: "Other",
    },
];

export const facilityDetails = (item) => {
    return [
        {
            list: [
                {
                    title: "General Info",
                    list: [
                        {
                            title: "Name",
                            desc: item?.name,
                        },

                        {
                            title: "Type",
                            desc: FacilityTypesList.find((type) => type?.id === item?.type)
                                ?.name,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Phone Number",
                            desc: item?.phone,
                            phoneRow: true,
                        },
                    ],
                },

                {
                    title: "Address",
                    list: [
                        {
                            title: "Street",
                            desc: item?.address?.street,
                        },

                        {
                            title: "Unit/Suit #",
                            desc: item?.address?.unitNumber,
                        },
                    ],
                },
                {
                    list: [
                        {
                            title: "City",
                            desc: item?.address?.city,
                        },

                        {
                            title: "State",
                            desc: item?.address?.state,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Country",
                            desc: item?.address?.country,
                        },

                        {
                            title: "Zip Code",
                            desc: item?.address?.zip,
                        },
                    ],
                },
            ],
        },
    ];
};

export const facilitiesHead = () => {
    return [
        {title: "Name", name: "name", searchKey: 'name', sortType: "name"},
        {title: "Address", name: "address", searchKey: 'address.formattedAddress', custom: false},
        {
            title: "Phone Number",
            name: "phone",
            searchKey: 'phone',
            custom: false,
        },
        {
            title: "Type",
            name: "type",
            filterList: FacilityTypesList,
            disabled: true,
            multiple: true,
        },
        {
            title: "Status",
            name: "status",
            disabled: true,
            filterList: [{name: "All", id: "All"}, ...allStatusesList],
            width: 149
        },
        {title: "Action", disabled: true, custom: false, width: "116px"},
    ];
};

export const facilitiesBody = ({handleDelete, handleEit}) => {
    return [
        {
            rowText: (item) => <TextToolTip text={item?.name} content={item?.name}/>,
        },

        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.address?.formattedAddress}
                    content={item?.address?.formattedAddress}
                />
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.phone} content={item?.phone} phoneRow/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip
                    text={FacilityTypesList.find((type) => type?.id === item?.type)?.name}
                    content={
                        FacilityTypesList.find((type) => type?.id === item?.type)?.name
                    }
                />
            ),
        },

        {
            rowText: (item) => <Statuses status={item?.status}/>,
        },

        {
            rowText: (item) => (
                <div className="flex-all-center" style={{gap: 8}}>
                    <EditActionBtn onClick={() => handleEit(item)}/>
                    <DeleteActionBtn onClick={() => handleDelete(item)}/>
                </div>
            ),
            notClickable: true,
        },
    ];
};

export const emptyState = (addFacility) => {
    return {
        emptyBtnText: 'Add Facilities',
        notTitleText: 'No facilities added yet',
        notDescText: 'Add your first facility to manage pickup and drop-off locations more efficiently.',
        EmptySvg: Svg.EmptyEmployees,
        clickToEmptyAddButton: () => addFacility(),
    }
}